import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { AuthUser } from '../models/auth-user.model';
import { AppConfig } from "../../app.config";

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  url = AppConfig.settings?.apiUrls.giganceApi;

  constructor(private http: HttpClient) { }

  login(user: string, pass: string, captcha: string) : Observable<AuthUser> {
    this.setBaseUrl();
    return this.http.post<AuthUser>(`${this.url}/Auth/authentication`, {
      email: user,
      password: pass,
      companyKey: AppConfig.settings?.company.key,
      captchaKey: captcha
    }).pipe(
        map(u => u)
    );
  }

  resetPassword(email: string) : Observable<boolean> {
    this.setBaseUrl();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'text/plain' // Establecer el tipo de contenido como texto plano
      })
    };
    let params = new HttpParams();
    params = params.set('email', email);
    params = params.set('companyKey', AppConfig.settings?.company.key);
    return this.http.post<boolean>(`${this.url}/Auth/ResetPassword`, params);
  }

  setNewPassword(user: string, hash: string, pass: string) : Observable<boolean> {
    this.setBaseUrl();

    return this.http.post<boolean>(`${this.url}/Auth/SetNewPassword/${user}/${hash}`, {
      password: pass,
      confirmPassword: pass
    });
  }

  refreshToken(accessToken: string, refreshToken: string) : Observable<AuthUser> {
    this.setBaseUrl();
    return this.http.post<AuthUser>(`${this.url}/Auth/refresh-token`, {
      accessToken: accessToken,
      refreshToken: refreshToken
    }).pipe(
      map(u => u)
    );
  }

  private setBaseUrl() {
    if (!this.url) {
      this.url = AppConfig.settings?.apiUrls.giganceApi;
    }
  }
}
